<template>
    <ElementLayout :parent="parent" :element="element">
        <DateTime :date-only="true" v-model="element.value" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" />
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import DateTime from '../../ui-elements/DateTime'

export default {
    data() {
        return {
        
        }
    },

    components: {
        ElementLayout,
        DateTime,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// DateControl.vue?5766f8fe